<template>
  <div>

    <van-cell-group inset>
      <van-field readonly clickable required :value="cabinValue" input-align="right" :right-icon="disabled ? '' : 'arrow'" placeholder="点击选择舱室" @click="open" >
        <template #label>
          <span class="input-left-label-hq">舱室</span>
        </template>
      </van-field>
      <van-field :required="csShow1" name="cs1" type="number" :readonly="disabled" v-show="csShow1" :value="cangshilifang1" @input="inputValue1" :rules="!disabled && csShow1 ? [{ validator:validatorCs1, message: '请填写前舱室立方'}] : []">
        <template #label>
          <span class="input-left-label-hq">前舱室立方</span>
        </template>
      </van-field>
      <van-field :required="csShow2" name="cs2" type="number" :readonly="disabled" v-show="csShow2" :value="cangshilifang2" @input="inputValue2" :rules="!disabled && csShow2 ? [{ validator:validatorCs2, message: '请填写'+cs2Lable }] : []">
        <template #label>
          <span class="input-left-label-hq">{{cs2Lable}}</span>
        </template>
      </van-field>
      <van-field :required="csShow3" name="cs3" type="number" :readonly="disabled" v-show="csShow3" :value="cangshilifang3" @input="inputValue3" :rules="!disabled && csShow3 ? [{ validator:validatorCs3, message: '请填写后舱室立方' }] : []">
        <template #label>
          <span class="input-left-label-hq">后舱室立方</span>
        </template>
      </van-field>
    </van-cell-group>
    <van-popup v-model="showPicker" position="bottom" @close="closePopup">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>

  </div>
</template>
<script >
import { Toast } from "vant"
export default {
  props: {
    cabinValue:{
      type: String,
      default: ""
    },
    cangshilifang1:{
      type: Number,
      default: 0
    },
    cangshilifang2:{
      type: Number,
      default: 0
    },
    cangshilifang3:{
      type: Number,
      default: 0
    },
    disabled:{
      type: Boolean,
      default: false
    },
  },

  watch: {
    cabinValue : {
      handler(newVal) {
        switch (newVal) {
          case '单舱':
            this.csShow1 = false;
            this.csShow2 = false;
            this.csShow3 = false;
            this.cs2Lable = '中舱室立方';
            this.$emit("getCsValue1",0);
            this.$emit("getCsValue2",0);
            this.$emit("getCsValue3",0);
            break;
          case '双舱':
            this.csShow1 = true;
            this.csShow2 = true;
            this.csShow3 = false;
            this.cs2Lable = '后舱室立方';
            this.$emit("getCsValue3",0);
            break;
          case '三舱':
            this.csShow1 = true;
            this.csShow2 = true;
            this.csShow3 = true;
            this.cs2Lable = '中舱室立方';

            break;
          default:
            this.csShow1 = false;
            this.csShow2 = false;
            this.csShow3 = false;
        }
      },
      immediate:true,
      deep:true
    }
  },
  data() {
    return {
      columns: ['单舱', '双舱', '三舱'],
      showPicker: false,
      csShow1:false,
      csShow2:false,
      csShow3:false,
      cs2Lable:"中舱室立方",
    };
  },

  methods: {
    open() {
      if (!this.disabled) {
        this.showPicker = true
        this.$driverObj.destroy()
      }
    },
    closePopup() {
      this.$emit('close')
    },
    validatorCs1(val){
      if(this.csShow1)
      {
        if (parseFloat(val)<=0) {
          Toast.fail('请填写前舱室立方');
          return false;
        }
        return parseFloat(val);
      }
    },
    validatorCs2(val){
      if(this.csShow2)
      {
        if (parseFloat(val)<=0) {
          Toast.fail('请填写'+this.cs2Lable);
          return false;
        }
        return parseFloat(val);
      }
    },
    validatorCs3(val){
      if(this.csShow3)
      {
        if (parseFloat(val)<=0) {
          Toast.fail('请填写后舱室立方');
          return false;
        }
        return parseFloat(val);
      }
    },
    onConfirm(value) {
      this.$emit('setCabin', value);
      this.showPicker = false;
    },
    inputValue1(value)
    {
      this.$driverObj.refresh()
      this.$emit("getCsValue1",parseFloat(value));
    },
    inputValue2(value)
    {
      this.$driverObj.refresh()
      this.$emit("getCsValue2",parseFloat(value));
    },
    inputValue3(value)
    {
      this.$driverObj.refresh()
      this.$emit("getCsValue3",parseFloat(value));
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
